<script lang="ts" setup>
import { isChristmasTime } from '~/constants/christmas';

const route = useRoute();

const handleOnLogoClick = () => {
  if (route.path === '/' || route.name === 'entity') document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const link = computed(() => {
  if (route.path === '/' || route.name === 'entity') return route.path;
  else return '/';
});
</script>

<template>
  <div class="header__logo">
    <nuxt-link
      :to="link"
      class="header__logo-link"
      style="position: relative"
      @click="handleOnLogoClick"
    >
      <NuxtImg
        v-if="isChristmasTime()"
        src="/images/logo-xmas-hat.svg"
        alt=""
        width="32"
        height="32"
        style="position: absolute; left: -11px; top: -16px"
      />
      <NuxtImg
        src="/images/new/logo.svg"
        alt="Бегемот"
        width="30"
        height="30"
      />
      <span>Бегемот</span>
    </nuxt-link>
  </div>
</template>

<style lang="scss" scoped>
.header__logo {
  display: flex;
  flex-direction: row;
  gap: 8px;
}

.header__logo-link {
  padding: 0 4px;
  display: flex;
  align-items: center;
  color: $foreground-contrast;
  gap: 8px;
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;

  @include media-breakpoint-down(md) {
    font-size: 18px;
    img {
      width: 32px;
    }
  }
}
</style>
